import { PropsWithChildren, forwardRef, ReactNode, InputHTMLAttributes } from 'react'
import { cn } from '@utils'
import { cva, VariantProps } from 'class-variance-authority'

export const inputSurfaceVariants = cva(
  'block w-full border border-cw-lighter-grey-stroke bg-transparent focus-visible:border-cw-purple outline-none transition-all',
  {
    variants: {
      variant: {
        default: 'h-22 px-5 pt-6 rounded-medium',
        unstyled: 'h-10 p-5 rounded-xl',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
)

export type InputProps = PropsWithChildren<
  InputHTMLAttributes<HTMLInputElement> &
    VariantProps<typeof variants> & {
      startIcon?: ReactNode
      endIcon?: ReactNode
      label?: string
      isInvalid?: boolean
    }
>

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, variant, isInvalid, ...props },
  ref,
) {
  return (
    <input
      ref={ref}
      className={cn(inputSurfaceVariants({ variant, className }), {
        'border-cw-system-red text-cw-system-red focus-visible:border-cw-system-red':
          isInvalid,
      })}
      autoComplete={'off'}
      {...props}
    />
  )
})
